import styled from "styled-components";
import AdminLayout from "../../layouts/AdminLayout/AdminLayout";

export const AdminLayoutHomePage = styled(AdminLayout)`
  margin-top: 0;
`;
